module.exports = __webpack_public_path__ + "static/SmallScreensGif-51347db2c6fe80ef332ce442b33c766d.gif";